// What an error report from the browser may carry (ISO #1735 15.5): the page
// it happened on, never a request body, cookies, headers or the query string
// (share links and previews carry tokens there). Used as Sentry's
// beforeSend, beforeSendTransaction and beforeBreadcrumb.

interface ScrubbableRequest {
  url?: string
  data?: unknown
  cookies?: unknown
  headers?: unknown
  query_string?: unknown
}

const stripQuery = (url: string): string => url.split(/[?#]/, 1)[0]

/** Scrubs an error or transaction event in place and returns it. */
export function scrubSentryEvent<E extends { request?: ScrubbableRequest; transaction?: string }>(event: E): E {
  if (typeof event.transaction === 'string') {
    event.transaction = stripQuery(event.transaction)
  }
  const request = event.request
  if (!request) return event
  delete request.data
  delete request.cookies
  delete request.headers
  delete request.query_string
  if (typeof request.url === 'string') {
    request.url = stripQuery(request.url)
  }
  return event
}

/** Strips the query from a breadcrumb's fetch/xhr url and navigation to/from. */
export function scrubSentryBreadcrumb<B extends { data?: { [key: string]: unknown } }>(crumb: B): B {
  const data = crumb.data
  if (!data) return crumb
  for (const key of ['url', 'to', 'from']) {
    const value = data[key]
    if (typeof value === 'string') data[key] = stripQuery(value)
  }
  return crumb
}
